<template>
  <div>
    <div class="container-custom d-flex align-items-center">
      <div class="title me-auto">{{ $t('gallery') }}</div>
      <div class="custom-navigation d-none d-md-flex">
        <button class="me-2" @click="prev">
          <div class="arrow-icons">
            <ArrowBackWhiteIcon/>
          </div>
        </button>
        <button @click="next">
          <div class="arrow-icons">
            <ArrowForwardIcon/>
          </div>
        </button>
      </div>
    </div>
    <div class="gallery-carousel">
      <Carousel ref="carousel" :breakpoints="breakpoints" v-bind="settings">
        <Slide v-for="(img, index) in imgUrls" :key="index">
          <div
              :style="getBackgroundStyle(img.imageUrl)"
              class="carousel__item"
              @click="showLightbox(index)"
          >
          </div>
        </Slide>
      </Carousel>
      <vue-easy-lightbox
          :hideControls="true"
          :imgs="lightboxImages"
          :index="index"
          :visible="visible"
          @hide="handleHide"
      />
    </div>

  </div>
</template>

<script>
import {defineComponent} from 'vue';
import {Carousel, Slide} from 'vue3-carousel';
import VueEasyLightbox from 'vue-easy-lightbox';
import 'vue3-carousel/dist/carousel.css';
import ArrowForwardIcon from '@/components/Common/Icons/ArrowForwardIcon.vue';
import ArrowBackWhiteIcon from '@/components/Common/Icons/ArrowBackWhiteIcon.vue';

export default defineComponent({
  name: 'GalleryMain',
  components: {
    ArrowBackWhiteIcon,
    ArrowForwardIcon,
    Carousel,
    Slide,
    VueEasyLightbox,
  },
  props: {
    imgUrls: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      visible: false,
      index: 0,
      settings: {
        itemsToShow: 1.2,
        snapAlign: 'center',
      },
      breakpoints: {
        700: {
          itemsToShow: 3.5,
          snapAlign: 'center',
        },
        1024: {
          itemsToShow: 4,
          snapAlign: 'start',
        },
      },
    };
  },
  computed: {
    lightboxImages() {
      return this.imgUrls ? this.imgUrls.map((img) => img.imageUrl) : [];
    },
  },
  methods: {
    showLightbox(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    next() {
      if (this.$refs.carousel) {
        this.$refs.carousel.next();
      }
    },
    prev() {
      if (this.$refs.carousel) {
        this.$refs.carousel.prev();
      }
    },
    getBackgroundStyle(imageUrl) {
      console.log('Background Image URL:', imageUrl);
      return {
        backgroundImage: `url(${imageUrl})`,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
.carousel__item {
  border-radius: 30px;
  overflow: hidden;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 300px;
  margin: 0 10px;

}

.title {
  font-size: $title-h4;
  color: $color-brown;
  padding: $spacing-3 0;
}

.custom-navigation {
  margin: 20px;

  .arrow-icons {
    transform: scale(0.6);
  }

  button {
    background-color: $color-blue-accent;
    border: none;
    color: white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      background-color: $color-blue-secondary;
    }
  }
}

@media screen and (min-width: 768px) {
  .carousel__item {
    height: 400px;
  }
  .gallery-carousel {
    padding-left: 60px;
  }
}
</style>
